import React from 'react'
import * as Styled from './modalStyled'

const Modal = props => (
  <Styled.ModalMainDiv>
    <Styled.ModalDiv
      style={{
        width: '660px',
        transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: props.show ? 1 : 0,
      }}
    >
      {/* <Styled.CloseModalDiv onClick={e => props.close(e)}>&times;</Styled.CloseModalDiv> */}
      <Styled.ModalHeadingDiv>{props.heading}</Styled.ModalHeadingDiv>
      {props.children}
    </Styled.ModalDiv>
    <Styled.ModalWrapDiv
      style={{ display: props.show ? 'block' : 'none' }}
      onClick={e => props.close(e)}
    />
  </Styled.ModalMainDiv>
)

export default Modal
